import { empty as empty$1, andThen as andThen$1, mapName as mapName$1, nested as nested$1, unnested as unnested$1 } from '../../internal/configProvider/pathPatch.esm.js';

/**
 * @since 2.0.0
 */

/**
 * Represents a description of how to modify the path to a configuration
 * value.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const andThen = andThen$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const mapName = mapName$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const nested = nested$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const unnested = unnested$1;

export { andThen, empty, mapName, nested, unnested };
